export const UPDATE_STEP = 'update_step';
export const USER_TYPE = 'user_type';
export const SHOW_OTHER = 'show_other';
export const QUESTION = 'question';